import { Component, Injector, TemplateRef, WritableSignal, effect, inject, input, model, signal } from '@angular/core';
import { AuthService } from '../../auth/auth.service';
import { SessionService } from '../../services/session.service';

@Component({
  selector: 'data-input',
  templateUrl: './data-input.component.html',
  standalone: false
})
export class DataInputComponent {
  injector = inject(Injector);
  session = inject(SessionService);
  private authService = inject(AuthService);

  fieldModel = model.required();

  enableDragDrop = input<boolean>(false);
  ismField = input.required<any>();
  templateRef = input<TemplateRef<any>>();

  fieldLabel: WritableSignal<string> = signal(undefined);
  fieldName: WritableSignal<string> = signal(undefined);
  fieldType: WritableSignal<string> = signal(undefined);
  fieldRequired: WritableSignal<boolean> = signal(false);
  fieldReadOnly: WritableSignal<boolean> = signal(false);
  fieldHidden: WritableSignal<boolean> = signal(false);

  fieldMin: WritableSignal<number | undefined> = signal(undefined);
  fieldMax: WritableSignal<number | undefined> = signal(undefined);

  determinePrivilege (original: string, newPrivilege: string): string {
    let returnValue: string;
    switch (newPrivilege) {
      case 'hidden':
        returnValue = 'hidden';
        break;
      case 'view':
        returnValue = 'view';
        break;
      case 'edit':
        returnValue = 'edit';
        break;
      default:
        returnValue = original;
        break;
    }
    return returnValue;
  };

  constructor () {
    effect(() => {
      if (!this.ismField()) {
        return;
      }
      this.fieldName.set(this.ismField().fieldName);
      this.fieldLabel.set(this.ismField().fieldLabel);
      this.fieldType.set(this.ismField().inputType);
      this.fieldRequired.set(this.ismField()?.required || false);

      let privilege = this.determinePrivilege("edit", this.ismField()?.privilege);
      let smPriv = this.ismField()?.smPriv;
      let adminPriv = this.ismField()?.adminPriv;
      // console.log(this.ismField().fieldName, 'privilege: ', privilege, smPriv, adminPriv);

      if (privilege != 'edit') {
        if (this.authService.isMaster()) {
          privilege = this.determinePrivilege(privilege, adminPriv);
        }
        else if (this.authService.isMarshal()) {
          privilege = this.determinePrivilege(privilege, smPriv);
        }
      }

      let isHidden = privilege === 'hidden';
      this.fieldHidden.set(isHidden);

      let viewOnly = privilege === 'view';
      let canEdit = !isHidden && !viewOnly;
      this.fieldReadOnly.set(!canEdit);
      // console.log('privilege', privilege, 'isHidden: ', isHidden, 'viewOnly: ', viewOnly, 'canEdit: ', canEdit);

      let min = this.ismField()?.fieldMin || undefined;
      if (min != null || min === 0) {
        this.fieldMin.set(min);
      }

      let max = this.ismField()?.fieldMax || undefined;
      if (max != null || max === 0) {
        this.fieldMax.set(max);
      }
    });
  };
};
